import { SURVEY_TEXT_FIELDS } from '@constants/surveys';

export const getSurveyLanguageSet = (customTextsEnabled, texts) =>
    customTextsEnabled && texts?.length ? texts.map(text => text.language) : null;

export const visibleQuestionLanguages = (questionLangs, languageSet) => {
    if (!languageSet) return questionLangs;
    const inSet = questionLangs.filter(question => languageSet.includes(question.language));
    return inSet.length > 0 ? inSet : questionLangs;
};

export const getSurveyTextFields = ratingEnabled =>
    SURVEY_TEXT_FIELDS.filter(field => ratingEnabled || !field.ratingOnly);

export const getSurveyTextError = (value, field) => {
    const text = (value || '').trim();
    if (!text) return field.optional ? null : 'validation.required';
    if (text.length > field.maxLength) return 'validation.maxLength';
    return null;
};

export const isSurveyTextComplete = (text, fields) =>
    fields.every(field => !getSurveyTextError(text?.[field.name], field));

export const buildInitialSurveyTexts = (primaryLanguage, questions, offeredLanguages) => {
    const questionLanguages = Object.values(questions || {})
        .flat()
        .map(question => question.language)
        .filter(language => offeredLanguages.includes(language));
    return [...new Set([primaryLanguage, ...questionLanguages])].map(language => ({
        language,
        title: '',
        positiveMessage: '',
        negativeMessage: '',
    }));
};
